<template>
  <div class="box noBtn" style="background: #fff" v-if="list.length > 0">
    <!-- 投标人 -->
    <div>
      <table class="show">
        <colgroup width="160px"></colgroup>
        <tr v-for="(item, index) in list" :key="index">
          <td style="width: 350px">{{ item.qymc }}</td>
          <td v-if="index == list.length - 1 && !list[list.length - 1].bjje">
            <el-input
            type="text"
              v-model.number="inputPrice"
              placeholder="请输入报价金额"
              oninput="value=value.replace(/^\.+|[^\d.]/g,'')">
            ></el-input>
          </td>
          <td v-else>{{ item.bjje }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inputPrice: "",
      list: [],
      lastPrice: "",
      bjcs: "",
      qymc: "",
      scje: "", // 上一次输入的金额
    };
  },
  props: ["djlcId"],
  created() {
    this.getListData();
  },
  methods: {
    async getListData() {
      let para = { djlcId: this.djlcId };
      // let para = { djlcId: "投标谢大帅" };
      try {
        let res = await this.$api.tbrdcbjquery(para);
        if (res.status == 200) {
          this.list = res.data.data.tbrdcbj;
          if (this.list.length > 0) {
            this.lastPrice = this.list[this.list.length - 1].bjje;
            this.bjcs = this.list[this.list.length - 1].bjcs;
            this.qymc = this.list[0].qymc;
            this.scje = this.list[this.list.length - 2].bjje;
          }
          this.$emit("isShow", this.lastPrice);
        } else {
          this.$message({ type: "error", message: res.message });
        }
      } catch (err) {
        console.log("投标人", err);
      }
    },
    tbrDo(lx) {
      if (lx == "tbbj") {
        this.sendListData();
      }
    },
    // 提交报价
    async sendListData() {
      let para = {};
      para.qymc = this.qymc;
      if (!this.inputPrice) {
        para.bjje = this.scje;
      } else {
        para.bjje = this.inputPrice;
      }
      para.num = this.bjcs;
      try {
        let res = await this.$api.bjjeoverride(para);
        if (res.status == 200) {
          if (res.data.data.status=='false') {
            this.$message({ type: "error", message: '确认时间已过无法提交新报价!' });
          }
          this.getListData();
        } else {
          this.$message({ type: "error", message: res.message });
        }
      } catch (err) {
        console.log("投标人-上传报价", err);
      }
    },
  },
};
</script>

<style lang='scss' scoped>
</style>
